const getBrandIds = (pageData = {}) => {
  if (!pageData.brandIds || !pageData.brandIds.length) return null;
  return pageData.brandIds;
};

export default getBrandIds;
